import { SubscriberSummary } from './subscriberSummary';

export interface SubscriberRegretSummary extends SubscriberSummary {
  Multa: string;
  Estorno: string;
  'Á cobrar': string;
  Motivo: string;
  Justificativa: string;
}
